// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","button-default":"Button_button-default__4h6cL","button-outlined":"Button_button-outlined__Mr+a1","active":"Button_active__iTrrO"};